export enum merchantAccountStatus {
  active = "active",
  disabled = "disabled",
}
